(function() {
  "use strict";

  angular
    .module("app")
    .factory("LegendService", ["$http", "$q", LegendService]);

  function LegendService($http, $q) {
    var service = {
      getLegend: getLegend
    };

    function getLegend(indicatorID) {
      var deferred = $q.defer();

      $http({
        method: "GET",
        url: "api/AssetMapping/GetLegend?id=" + indicatorID,
        cache: true // this data rarely updates, no need for an instant re-request
      })
        .success(function(data) {
          deferred.resolve(data);
        })
        .error(function(error) {
          deferred.reject();
        });

      return deferred.promise;
    }

    return service;
  }
})();
